export default __webpack_public_path__ + "static/media/AVIX.c9b0c01b.png";